import Fragment from './fragment.js'

export default {
    fragment: Fragment,
}
